import { Button, Checkbox, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import React from "react";
import DatePickerComponent from "../DatePickerComponent";
import DropDownComponent from "../DropDownComponent";
import InputComponent from "../InputComponent";
import PhoneNumberInput from "../PhoneNumberInput";
import { useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { useEffect } from "react";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
} from "firebase/storage";
import { showCustomToast } from "../Misc/CustomToast";
import InputComponentReadOnly from "../InputComponentReadOnly";
import DropDownComponentSorted from "../DropDownComponentSorted";
import { useAuth } from "../../contexts/AuthContext";
import TextFieldComponentMobile from "../TextFieldComponentMobile";
import DropDownAllStaffs from "../Dropdowns/DropDownAllStaffs";
import UploaderGeneralInfosEncapsulated from "../Updloader/UploaderGeneralInfosEncapsulated";
import DropDownSpecificStaff from "../Dropdowns/DropDownSpecificStaff";
import LineLogsMobile from "../Lines/LineLogsMobile";
import DropDownRoomsNumber from "../Dropdowns/DropdownRoomsNumber";

import DropDownComponentSortedFixed from "../DropDownComponentSortedFixed";
import DatePickerComponentWithTimeMobile from "../DatePickerComponentWithTimeMobile";
import StandardDrawer, { StandardDrawerFooter, StandardDrawerHeader } from "../forms/StandardDrawer";
import "../PreAdmission.css";
import rehabs, { getRehabByClient } from "../../api/rehabs";

function GeneralInformationMobile(props) {
  useEffect(() => {}, [props.clientId]);

  //VARIABLES
  const maxSizePicFile = 2 * 1024 * 1024;

  //STATE
  const [dischargeDate, setDischargeDate] = useState(
    props.actualDischargeDate || null
  );
  const [isModified, setIsModified] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTherapist, setSelectedTherapist] = useState(
    props.selectedTherapist || ""
  );
  const [assignedSupportWorker, setAssignedSupportWorker] = useState(
    props.assignedSupportWorker || ""
  );
  const [genderOther, setGenderOther] = useState(props.genderOther || "");
  const [sexualOrientationOther, setSexualOrientationOther] = useState(
    props.sexualOrientationOther || ""
  );
  const [livingWithOther, setLivingWithOther] = useState(
    props.livingWithOther || ""
  );
  const [province, setProvince] = useState(props.province || "");
  const [emergencyRelationshipOther, setEmergencyRelationshipOther] = useState(
    props.emergencyRelationshipOther || ""
  );
  const [firstName, setFirstName] = useState(props.firstName || "");
  const [lastName, setLastName] = useState(props.lastName || "");
  const [nickname, setNickname] = useState(props.nickname || "");
  const [clientSource, setClientSource] = useState(props.clientSource || "");

  const [gender, setGender] = useState(props.gender || "");
  const [sexualOrientation, setSexualOrientation] = useState(
    props.sexualOrientation || ""
  );
  const [personalEmail, setPersonalEmail] = useState(props.personalEmail || "");
  const [phoneNumber, setPhoneNumber] = useState(props.phoneNumber || "");
  const [dob, setDob] = useState(props.dob || "");
  const [currentAddress, setCurrentAddress] = useState(
    props.currentAddress || ""
  );
  const [city, setCity] = useState(props.city || "");
  const [nationality, setNationality] = useState(props.nationality || "");
  const [country, setCountry] = useState(props.country || "");
  const [rehabId, setRehabId] = useState(getRehabByClient(props)?.id || "");
  const [durationOfStay, setDurationOfStay] = useState(
    props.durationOfStay || ""
  );
  const requiresDurationOfStay =
    rehabId !== "miracles_asia_philippines" &&
    props.rehabCountry !== "Philippines";
  const [dateOfAdmission, setDateOfAdmission] = useState(
    props.dateOfAdmission || ""
  );
  const [
    projectedResidentialDischargeDate,
    setProjectedResidentialDischargeDate,
  ] = useState(props.projectedResidentialDischargeDate || "");
  const [maritalStatus, setMaritalStatus] = useState(props.maritalStatus || "");
  const [livingWith, setLivingWith] = useState(props.livingWith || "");
  const [projectedProgramCompletionDate, setProjectedProgramCompletionDate] =
    useState(props.projectedProgramCompletionDate || "");
  const [passportNumber, setPassportNumber] = useState(
    props.passportNumber || ""
  );
  const [roomNumber, setRoomNumber] = useState(props.roomNumber || "");
  const [visaExpirationDate, setVisaExpirationDate] = useState(
    props.visaExpirationDate || ""
  );
  const [emergencyContactFirstName, setEmergencyContactFirstName] = useState(
    props.emergencyContactFirstName || ""
  );
  const [emergencyContactLastName, setEmergencyContactLastName] = useState(
    props.emergencyContactLastName || ""
  );
  const [emergencyContactRelationship, setEmergencyContactRelationship] =
    useState(props.emergencyContactRelationship || "");
  const [emergencyContactPhoneNumber, setEmergencyContactPhoneNumber] =
    useState(props.emergencyContactPhoneNumber || "");
  const [emergencyContactEmail, setEmergencyContactEmail] = useState(
    props.emergencyContactEmail || ""
  );
  const [emergencyContactAddress, setEmergencyContactAddress] = useState(
    props.emergencyContactAddress || ""
  );
  const [emergencyContactCity, setEmergencyContactCity] = useState(
    props.emergencyContactCity || ""
  );
  const [emergencyContactNationality, setEmergencyContactNationality] =
    useState(props.emergencyContactNationality || "");
  const [emergencyContactCountry, setEmergencyContactCountry] = useState(
    props.emergencyContactCountry || ""
  );
  const [payerName, setPayerName] = useState(props.payerName || "");
  const [payerPhoneNumber, setPayerPhoneNumber] = useState(
    props.payerPhoneNumber || ""
  );
  const [inTakestaffName, setInTakestaffName] = useState(
    props.inTakestaffName || ""
  );
  const [intakeStaffId, setIntakeStaffId] = useState(props.intakeStaffId || "");
  const [intakeStaffEmail, setIntakeStaffEmail] = useState(
    props.intakeStaffEmail || ""
  );
  const [clientStatus, setClientStatus] = useState(props.clientStatus || "");
  const [age, setAge] = useState("NA");
  const [, setLastModification] = useState(
    props.lastModification || ""
  );
  const [files] = useState([]);
  const [, setFileLinks] = useState(props.fileUrls || []);
  const [acknowledgmentOfPresence, setAcknowledgmentOfPresence] = useState(
    props.emergencyCheckbox0 || false
  );
  const [clinicalInformation, setClinicalInformation] = useState(
    props.emergencyCheckbox1 || false
  );
  const [clientIdState] = useState(props.clientId || "");
  const [psychEvaluation, setPsychEvaluation] = useState(
    props.emergencyCheckbox2 || false
  );
  const [referralLetter, setReferralLetter] = useState(
    props.emergencyCheckbox3 || false
  );
  const [labData, setLabData] = useState(props.emergencyCheckbox4 || false);
  const [progressNotes, setProgressNotes] = useState(
    props.emergencyCheckbox5 || false
  );
  const [medicalRecords, setMedicalRecords] = useState(
    props.emergencyCheckbox6 || false
  );
  const [progressInTreatment, setProgressInTreatment] = useState(
    props.emergencyCheckbox7 || false
  );
  const [psychosocialAssessment, setPsychosocialAssessment] = useState(
    props.emergencyCheckbox8 || false
  );
  const [medicationInfo, setMedicationInfo] = useState(
    props.emergencyCheckbox9 || false
  );
  const [treatmentPlan, setTreatmentPlan] = useState(
    props.emergencyCheckbox10 || false
  );
  const [physicalAssessment, setPhysicalAssessment] = useState(
    props.emergencyCheckbox11 || false
  );
  const [dischargeSummary, setDischargeSummary] = useState(
    props.emergencyCheckbox12 || false
  );
  const [familyHistory, setFamilyHistory] = useState(
    props.emergencyCheckbox13 || false
  );
  const [dischargePlan, setDischargePlan] = useState(
    props.emergencyCheckbox14 || false
  );
  const [admissionDischargeDates, setAdmissionDischargeDates] = useState(
    props.emergencyCheckbox15 || false
  );
  const [otherInfo, setOtherInfo] = useState(
    props.emergencyCheckboxContent15 || ""
  );
  const [otherInfoInput, setOtherInfoInput] = useState(
    props.emergencyCheckboxContent15Input || ""
  );

  const [logs, setLogs] = useState([]);
  const [isModalLogsOpen, setIsModalLogsOpen] = useState(false);
  const [, setIsLoadingFetchLogs] = useState(false);
  const [selectedLog, setSelectedLog] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const closeDetailLogsModal = () => setIsDetailsModalOpen(false);
  const closeLogsModal = () => setIsModalLogsOpen(false);
  const [profilePicture] = useState(
    props.profilePicture || ""
  );

  const [therapistAppointment, setTherapistAppointment] = useState(
    props.therapistAppointment || ""
  );
  const [supportWorkerAppointment, setSupportWorkerAppointment] = useState(
    props.supportWorkerAppointment || ""
  );
  const [medicalAppointment, setMedicalAppointment] = useState(
    props.medicalAppointment || ""
  );
  const [visaAppointment, setVisaAppointment] = useState(
    props.visaAppointment || ""
  );
  const [stepsAppointment, setStepsAppointment] = useState(
    props.stepsAppointment || ""
  );
  const [massageDay, setMassageDay] = useState(props.massageDay || "");

  const [therapistAppointmentDays, setTherapistAppointmentDays] = useState(
    props.therapistAppointmentDays || ""
  );
  const [therapistAppointmentTime, setTherapistAppointmentTime] = useState(
    props.therapistAppointmentTime || ""
  );

  // pour Support Worker Appt
  const [supportWorkerAppointmentDays, setSupportWorkerAppointmentDays] =
    useState(props.supportWorkerAppointmentDays || "");
  const [supportWorkerAppointmentTime, setSupportWorkerAppointmentTime] =
    useState(props.supportWorkerAppointmentTime || "");

  // pour 12 Steps Appt
  const [stepsAppointmentDays, setStepsAppointmentDays] = useState(
    props.stepsAppointmentDays || ""
  );
  const [stepsAppointmentTime, setStepsAppointmentTime] = useState(
    props.stepsAppointmentTime || ""
  );

  // handlers
  const handleSupportWorkerAppointmentDaysChange = (v) => {
    setSupportWorkerAppointmentDays(v);
    setIsModified(true);
  };
  const handleSupportWorkerAppointmentTimeChange = (v) => {
    setSupportWorkerAppointmentTime(v);
    setIsModified(true);
  };
  const handleStepsAppointmentDaysChange = (v) => {
    setStepsAppointmentDays(v);
    setIsModified(true);
  };
  const handleStepsAppointmentTimeChange = (v) => {
    setStepsAppointmentTime(v);
    setIsModified(true);
  };

  const generateTimeOptions = () => {
    const opts = [];
    for (let h = 6; h <= 22; h++) {
      //
      for (let m of [0, 15, 30, 45]) {
        const date = new Date();
        date.setHours(h, m);
        opts.push({
          value: `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`,
          label: date.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
          }),
        });
      }
    }
    return opts;
  };

  const handleTherapistAppointmentDaysChange = (value) => {
    setTherapistAppointmentDays(value);
    setIsModified(true);
  };
  const handleTherapistAppointmentTimeChange = (value) => {
    setTherapistAppointmentTime(value);
    setIsModified(true);
  };

  // FUNCTIONS

  const handleAcknowledgmentOfPresenceChange = (e) => {
    setIsModified(true);
    setAcknowledgmentOfPresence(e.target.checked);
  };
  const handleClinicalInformationChange = (e) => {
    setIsModified(true);
    setClinicalInformation(e.target.checked);
  };
  const handleClientSourceChange = (value) => {
    setIsModified(true);
    setClientSource(value);
  };
  const handlePsychEvaluationChange = (e) => {
    setIsModified(true);
    setPsychEvaluation(e.target.checked);
  };
  const handleReferralLetterChange = (e) => {
    setIsModified(true);
    setReferralLetter(e.target.checked);
  };
  const handleLabDataChange = (e) => {
    setIsModified(true);
    setLabData(e.target.checked);
  };
  const handleProgressNotesChange = (e) => {
    setIsModified(true);
    setProgressNotes(e.target.checked);
  };
  const handleMedicalRecordsChange = (e) => {
    setIsModified(true);
    setMedicalRecords(e.target.checked);
  };
  const handleProgressInTreatmentChange = (e) => {
    setIsModified(true);
    setProgressInTreatment(e.target.checked);
  };
  const handlePsychosocialAssessmentChange = (e) => {
    setIsModified(true);
    setPsychosocialAssessment(e.target.checked);
  };
  const handleMedicationInfoChange = (e) => {
    setIsModified(true);
    setMedicationInfo(e.target.checked);
  };
  const handleTreatmentPlanChange = (e) => {
    setIsModified(true);
    setTreatmentPlan(e.target.checked);
  };
  const handlePhysicalAssessmentChange = (e) => {
    setIsModified(true);
    setPhysicalAssessment(e.target.checked);
  };
  const handleDischargeSummaryChange = (e) => {
    setIsModified(true);
    setDischargeSummary(e.target.checked);
  };
  const handleFamilyHistoryChange = (e) => {
    setIsModified(true);
    setFamilyHistory(e.target.checked);
  };
  const handleDischargePlanChange = (e) => {
    setIsModified(true);
    setDischargePlan(e.target.checked);
  };
  const handleAdmissionDischargeDatesChange = (e) => {
    setIsModified(true);
    setAdmissionDischargeDates(e.target.checked);
  };
  const handleOtherInfoChange = (e) => {
    setIsModified(true);
    setOtherInfo(e.target.checked);
  };

  const handleAssignedSupportWorkerChange = (value) => {
    setIsModified(true);
    setAssignedSupportWorker(value);
  };
  const handleOtherInfoInputChange = (e) => {
    setIsModified(true);
    setOtherInfoInput(e);
  };

  const handleProvinceChange = (event) => {
    setIsModified(true);
    setProvince(event);
  };

  const handleGenderOther = (event) => {
    setGenderOther(event);
    setIsModified(true);
  };

  const handleSexualOrientationOther = (event) => {
    setSexualOrientationOther(event);
    setIsModified(true);
  };

  const handleEmergencyRelationshipOther = (event) => {
    setEmergencyRelationshipOther(event);
    setIsModified(true);
  };

  const handleLivingWithOther = (event) => {
    setLivingWithOther(event);
    setIsModified(true);
  };

  const handleMaritalStatusChange = (event) => {
    setMaritalStatus(event);
    setIsModified(true);
  };

  const handleLivingWithChange = (event) => {
    setLivingWith(event);
    setIsModified(true);
  };

  const handleSelectedTherapistChange = (value) => {
    setSelectedTherapist(value);
    setIsModified(true);
  };

  const handleFirstNameChange = (event) => {
    setIsModified(true);
    setFirstName(event);
  };

  const handleLastNameChange = (event) => {
    setLastName(event);
    setIsModified(true);
  };

  const handleNicknameChange = (event) => {
    setNickname(event);
    setIsModified(true);
  };

  const handleGenderChange = (value) => {
    setGender(value);
    setIsModified(true);
  };

  const handleSexualOrientationChange = (value) => {
    setSexualOrientation(value);
    setIsModified(true);
  };

  const handlePersonalEmailChange = (event) => {
    setPersonalEmail(event);
    setIsModified(true);
  };

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
    setIsModified(true);
  };

  const handleDobChange = (value) => {
    setDob(value);
    setAge(getAge(value));
    setIsModified(true);
  };

  const handleCurrentAddressChange = (event) => {
    setCurrentAddress(event);
    setIsModified(true);
  };

  const handleCityChange = (event) => {
    setCity(event);
    setIsModified(true);
  };

  const handleNationalityChange = (value) => {
    setNationality(value);
    setIsModified(true);
  };

  const handleCountryChange = (value) => {
    setCountry(value);
    setIsModified(true);
  };

  const handleRehabChange = (event) => {
    setRehabId(event.target.value);
    setIsModified(true);
  };

  const handleDurationOfStayChange = (value) => {
    setDurationOfStay(value);
    setIsModified(true);
  };

  const handleDateOfAdmissionChange = (value) => {
    setDateOfAdmission(value);
    setIsModified(true);
  };

  const handleProjectedResidentialDischargeDateChange = (value) => {
    setProjectedResidentialDischargeDate(value);
    setIsModified(true);
  };

  const handleProjectedProgramCompletionDateChange = (value) => {
    setProjectedProgramCompletionDate(value);
    setIsModified(true);
  };

  const handlePassportNumberChange = (event) => {
    setPassportNumber(event);
    setIsModified(true);
  };

  // const handleRoomNumberChange = (event) => {
  //   setRoomNumber(event);
  //   setIsModified(true);
  // };

  const updateRoomOccupation = async (newRoomNumber, previousRoomNumber) => {
    if (previousRoomNumber) {
      // Supprimez la chambre précédemment assignée
      const previousRoomDocRef = doc(db, "RoomNumbers", previousRoomNumber);
      await deleteDoc(previousRoomDocRef);
    }

    if (newRoomNumber) {
      // Ajoutez la nouvelle chambre avec les informations du client
      const newRoomDocRef = doc(db, "RoomNumbers", newRoomNumber);
      await setDoc(newRoomDocRef, {
        occupied: true,
        clientId: clientIdState,
        clientFirstName: firstName, // Prénom du client
        clientLastName: lastName, // Nom du client
        profilePictureUrl: profilePicture, // Lien vers la photo de profil du client
      });
    }
  };

  const handleRoomNumberChange = async (event) => {
    const newRoomNumber = event;

    // Mise à jour de l'occupation de la chambre en tenant compte du clientStatus
    await updateRoomOccupation(newRoomNumber, roomNumber, clientStatus);

    // Enregistrer le nouveau numéro de chambre dans la collection client
    const clientRef = doc(db, "clients", props.clientId);
    await updateDoc(clientRef, { roomNumber: newRoomNumber });

    setIsModified(true);
    setRoomNumber(newRoomNumber);
  };

  const handleVisaExpirationDateChange = (value) => {
    setVisaExpirationDate(value);
    setIsModified(true);
  };

  const handleEmergencyContactFirstNameChange = (event) => {
    setEmergencyContactFirstName(event);
    setIsModified(true);
  };

  const handleEmergencyContactLastNameChange = (event) => {
    setEmergencyContactLastName(event);
    setIsModified(true);
  };

  const handleEmergencyContactRelationshipChange = (value) => {
    setEmergencyContactRelationship(value);
    setIsModified(true);
  };

  const handleEmergencyContactPhoneNumberChange = (value) => {
    setEmergencyContactPhoneNumber(value);
    setIsModified(true);
  };

  const handleEmergencyContactEmailChange = (event) => {
    setEmergencyContactEmail(event);
    setIsModified(true);
  };

  const handleEmergencyContactAddressChange = (event) => {
    setEmergencyContactAddress(event);
    setIsModified(true);
  };

  const handleEmergencyContactCityChange = (event) => {
    setEmergencyContactCity(event);
    setIsModified(true);
  };

  const handleEmergencyContactNationalityChange = (value) => {
    setEmergencyContactNationality(value);
    setIsModified(true);
  };

  const handleEmergencyContactCountryChange = (value) => {
    setEmergencyContactCountry(value);
    setIsModified(true);
  };

  const handlePayerNameChange = (event) => {
    setPayerName(event);
    setIsModified(true);
  };

  const handlePayerPhoneNumberChange = (value) => {
    setPayerPhoneNumber(value);
    setIsModified(true);
  };

  const handleDischargeDateChange = (value) => {
    setIsModified(true);
    setDischargeDate(value);
  };




  const handleMedicalAppointmentChange = (value) => {
    setMedicalAppointment(value);
    setIsModified(true);
  };

  const handleVisaAppointmentChange = (value) => {
    setVisaAppointment(value);
    setIsModified(true);
  };


  const handleMassageDayChange = (value) => {
    setMassageDay(value);
    setIsModified(true);
  };


  function getAge(dobTimestamp) {
    if (!dobTimestamp) {
      return "NA";
    }

    const dob = dobTimestamp.toDate(); // Convertit le timestamp Firestore en une date JavaScript
    const diff = Date.now() - dob.getTime();
    const ageDate = new Date(diff);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  useEffect(() => {
    setAge(getAge(dob));
  }, [dob]);

  const uploadFilesAndGetUrls = async (docId) => {
    const storage = getStorage();
    const fileUrls = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (file.size > maxSizePicFile) {
        showCustomToast(`File size exceeds the limit: ${file.name}`, "error");

        console.error(`File size exceeds the limit: ${file.name}`);
        continue; // Passez au fichier suivant dans la boucle
      }
      const filePath = `Documents/generalInfos/${docId}/${file.name}`;
      const storageRef = ref(storage, filePath);

      await uploadBytes(storageRef, file);
      const fileUrl = await getDownloadURL(storageRef);
      fileUrls.push({ url: fileUrl, name: file.name });
    }

    return fileUrls;
  };


  useEffect(() => {}, [files]);

  const updateClientData = async (clientId) => {
    if (firstName && lastName) {
      setIsLoading(true);
      try {
        const clientRef = doc(db, "clients", clientId);
        const fileUrls = await uploadFilesAndGetUrls(clientRef.id);
        const clientDoc = await getDoc(clientRef);
        const existingFileUrls = clientDoc.data().fileUrls || [];
        const mergedFileUrls = [...existingFileUrls, ...fileUrls];
        const selectedRehab =
          rehabs.find((rehab) => rehab.id === rehabId) || getRehabByClient(props);

        await updateDoc(clientRef, {
          selectedTherapist,
          firstName,
          lastName,
          nickname,
          gender,
          sexualOrientation,
          personalEmail,
          phoneNumber,
          dob,
          currentAddress,
          city,
          nationality,
          country,
          rehabId: selectedRehab.id,
          rehabName: selectedRehab.name,
          rehabCountry: selectedRehab.country,
          rehabLocation: selectedRehab.location,
          rehabTimezone: selectedRehab.timezone,
          rehabCurrency: selectedRehab.currency,
          durationOfStay,
          dateOfAdmission,
          projectedResidentialDischargeDate,
          maritalStatus,
          livingWith,
          projectedProgramCompletionDate,
          passportNumber,
          roomNumber,
          visaExpirationDate,
          emergencyContactFirstName,
          emergencyContactLastName,
          emergencyContactRelationship,
          emergencyContactPhoneNumber,
          emergencyContactEmail,
          emergencyContactAddress,
          emergencyContactCity,
          emergencyContactNationality,
          emergencyContactCountry,
          emergencyRelationshipOther,
          payerName,
          payerPhoneNumber,
          inTakestaffName,
          intakeStaffId,
          intakeStaffEmail,
          clientStatus,
          age,
          lastModification: serverTimestamp(),
          lastModificationDoneBy: currentUser.displayName,
          fileUrls: mergedFileUrls,
          genderOther,
          sexualOrientationOther,
          livingWithOther,
          province,
          emergencyCheckbox0: acknowledgmentOfPresence,
          emergencyCheckbox1: clinicalInformation,
          emergencyCheckbox2: psychEvaluation,
          emergencyCheckbox3: referralLetter,
          emergencyCheckbox4: labData,
          emergencyCheckbox5: progressNotes,
          emergencyCheckbox6: medicalRecords,
          emergencyCheckbox7: progressInTreatment,
          emergencyCheckbox8: psychosocialAssessment,
          emergencyCheckbox9: medicationInfo,
          emergencyCheckbox10: treatmentPlan,
          emergencyCheckbox11: physicalAssessment,
          emergencyCheckbox12: dischargeSummary,
          emergencyCheckbox13: familyHistory,
          emergencyCheckbox14: dischargePlan,
          emergencyCheckbox15: admissionDischargeDates,
          emergencyCheckboxContent15: otherInfo,
          emergencyCheckboxContent15Input: otherInfoInput,
          actualDischargeDate: dischargeDate,
          assignedSupportWorker: assignedSupportWorker,
          clientSource: clientSource,

          therapistAppointmentDays,
          therapistAppointmentTime,
          supportWorkerAppointment, // Ajoutez ici
          medicalAppointment, // Ajoutez ici
          visaAppointment, // Ajoutez ici
          stepsAppointment, // Ajoutez ici
          massageDay,
          supportWorkerAppointmentDays,
          supportWorkerAppointmentTime,
          stepsAppointmentDays,
          stepsAppointmentTime,
        });
        setIsModified(false);
        setIsLoading(false);

        const newData = {
          therapistAppointmentDays,
          therapistAppointmentTime,
          selectedTherapist,
          firstName,
          lastName,
          nickname,
          gender,
          sexualOrientation,
          personalEmail,
          phoneNumber,
          dob,
          currentAddress,
          city,
          nationality,
          country,
          rehabId: selectedRehab.id,
          rehabName: selectedRehab.name,
          rehabCountry: selectedRehab.country,
          rehabLocation: selectedRehab.location,
          rehabTimezone: selectedRehab.timezone,
          rehabCurrency: selectedRehab.currency,
          durationOfStay,
          dateOfAdmission,
          projectedResidentialDischargeDate,
          maritalStatus,
          livingWith,
          projectedProgramCompletionDate,
          passportNumber,
          roomNumber,
          visaExpirationDate,
          emergencyContactFirstName,
          emergencyContactLastName,
          emergencyContactRelationship,
          emergencyContactPhoneNumber,
          emergencyContactEmail,
          emergencyContactAddress,
          emergencyContactCity,
          emergencyContactNationality,
          emergencyContactCountry,
          emergencyRelationshipOther,
          payerName,
          payerPhoneNumber,
          inTakestaffName,
          intakeStaffId,
          intakeStaffEmail,
          clientStatus,
          age,
          lastModification: serverTimestamp(),
          lastModificationDoneBy: currentUser.displayName,
          fileUrls: mergedFileUrls,
          genderOther,
          sexualOrientationOther,
          livingWithOther,
          province,
          // provinceEmergencyContact,
          emergencyCheckbox0: acknowledgmentOfPresence,
          emergencyCheckbox1: clinicalInformation,
          emergencyCheckbox2: psychEvaluation,
          emergencyCheckbox3: referralLetter,
          emergencyCheckbox4: labData,
          emergencyCheckbox5: progressNotes,
          emergencyCheckbox6: medicalRecords,
          emergencyCheckbox7: progressInTreatment,
          emergencyCheckbox8: psychosocialAssessment,
          emergencyCheckbox9: medicationInfo,
          emergencyCheckbox10: treatmentPlan,
          emergencyCheckbox11: physicalAssessment,
          emergencyCheckbox12: dischargeSummary,
          emergencyCheckbox13: familyHistory,
          emergencyCheckbox14: dischargePlan,
          emergencyCheckbox15: admissionDischargeDates,
          emergencyCheckboxContent15: otherInfo,
          emergencyCheckboxContent15Input: otherInfoInput,
          actualDischargeDate: dischargeDate,
          assignedSupportWorker: assignedSupportWorker,
          clientSource: clientSource,
          therapistAppointment,
          supportWorkerAppointment,
          medicalAppointment,
          visaAppointment,
          stepsAppointment,
          massageDay,
        };
        const clientLogsRef = doc(
          collection(db, "logs-general-infos", clientId, "modifications")
        );

        const logEntry = {
          clientId,
          changes: newData, // ou une sélection spécifique de newData si tout n'est pas pertinent
          recordedBy: currentUser?.displayName,
          recordedAt: serverTimestamp(),
        };
        await setDoc(clientLogsRef, logEntry);

        showCustomToast("Client successfully updated!", "success");
      } catch (error) {
        console.error("Error updating client: ", error);
        setIsLoading(false);
        showCustomToast(`Error updating client: ${error}`, "error");
      }
    } else {
      showCustomToast(
        "Some mandatory fields are empty. Please check.",
        "error"
      );
    }
  };

  useEffect(() => {
    setSelectedTherapist(props.selectedTherapist || "");
    setFirstName(props.firstName || "");
    setLastName(props.lastName || "");
    setNickname(props.nickname || "");
    setGender(props.gender || "");
    setSexualOrientation(props.sexualOrientation || "");
    setPersonalEmail(props.personalEmail || "");
    setPhoneNumber(props.phoneNumber || "");
    setDob(props.dob || "");
    setCurrentAddress(props.currentAddress || "");
    setCity(props.city || "");
    setNationality(props.nationality || "");
    setCountry(props.country || "");
    setRehabId(getRehabByClient(props)?.id || "");
    setDurationOfStay(props.durationOfStay || "");
    setDateOfAdmission(props.dateOfAdmission || "");
    setProjectedResidentialDischargeDate(
      props.projectedResidentialDischargeDate || ""
    );
    setMaritalStatus(props.maritalStatus || "");
    setLivingWith(props.livingWith || "");
    setProjectedProgramCompletionDate(
      props.projectedProgramCompletionDate || ""
    );
    setPassportNumber(props.passportNumber || "");
    setRoomNumber(props.roomNumber || "");
    setVisaExpirationDate(props.visaExpirationDate || "");
    setEmergencyContactFirstName(props.emergencyContactFirstName || "");
    setEmergencyContactLastName(props.emergencyContactLastName || "");
    setEmergencyContactRelationship(props.emergencyContactRelationship || "");
    setEmergencyContactPhoneNumber(props.emergencyContactPhoneNumber || "");
    setEmergencyContactEmail(props.emergencyContactEmail || "");
    setEmergencyContactAddress(props.emergencyContactAddress || "");
    setEmergencyContactCity(props.emergencyContactCity || "");
    setEmergencyContactNationality(props.emergencyContactNationality || "");
    setEmergencyContactCountry(props.emergencyContactCountry || "");
    setPayerName(props.payerName || "");
    setPayerPhoneNumber(props.payerPhoneNumber || "");
    setInTakestaffName(props.inTakestaffName || "");
    setIntakeStaffId(props.intakeStaffId || "");
    setIntakeStaffEmail(props.intakeStaffEmail || "");
    setClientStatus(props.clientStatus || "");
    // setAge(props.age || "");
    setLastModification(props.lastModification || "");
    setFileLinks(props.fileUrls || "");
    setGenderOther(props.genderOther || "");
    setSexualOrientationOther(props.sexualOrientationOther || "");
    setLivingWithOther(props.livingWithOther || "");
    setEmergencyRelationshipOther(props.emergencyRelationshipOther || "");
    setProvince(props.province || "");
    setAcknowledgmentOfPresence(props.emergencyCheckbox0 || false);
    setClinicalInformation(props.emergencyCheckbox1 || false);
    setPsychEvaluation(props.emergencyCheckbox2 || false);
    setReferralLetter(props.emergencyCheckbox3 || false);
    setLabData(props.emergencyCheckbox4 || false);
    setProgressNotes(props.emergencyCheckbox5 || false);
    setMedicalRecords(props.emergencyCheckbox6 || false);
    setProgressInTreatment(props.emergencyCheckbox7 || false);
    setPsychosocialAssessment(props.emergencyCheckbox8 || false);
    setMedicationInfo(props.emergencyCheckbox9 || false);
    setTreatmentPlan(props.emergencyCheckbox10 || false);
    setPhysicalAssessment(props.emergencyCheckbox11 || false);
    setDischargeSummary(props.emergencyCheckbox12 || false);
    setFamilyHistory(props.emergencyCheckbox13 || false);
    setDischargePlan(props.emergencyCheckbox14 || false);
    setAdmissionDischargeDates(props.emergencyCheckbox15 || false);
    setOtherInfo(props.emergencyCheckboxContent15 || "");
    setOtherInfoInput(props.emergencyCheckboxContent15Input || "");
    setDischargeDate(props.actualDischargeDate || null);
    setAssignedSupportWorker(props.assignedSupportWorker || "");
    setClientSource(props.clientSource || "");
    setTherapistAppointment(props.therapistAppointment || "");
    setTherapistAppointment(props.therapistAppointment || "");
    setTherapistAppointmentDays(props.therapistAppointmentDays || "");
    setTherapistAppointmentTime(props.therapistAppointmentTime || "");
    setSupportWorkerAppointment(props.supportWorkerAppointment || "");
    setMedicalAppointment(props.medicalAppointment || "");
    setVisaAppointment(props.visaAppointment || "");
    setStepsAppointment(props.stepsAppointment || "");
    setMassageDay(props.massageDay || "");
    setSupportWorkerAppointmentDays(props.supportWorkerAppointmentDays || "");
    setSupportWorkerAppointmentTime(props.supportWorkerAppointmentTime || "");
    setStepsAppointmentDays(props.stepsAppointmentDays || "");
    setStepsAppointmentTime(props.stepsAppointmentTime || "");
  }, [
    props.supportWorkerAppointmentDays,
    props.supportWorkerAppointmentTime,
    props.stepsAppointmentDays,
    props.stepsAppointmentTime,
    props.clientSource,
    props.actualDischargeDate,
    props.selectedTherapist,
    props.firstName,
    props.lastName,
    props.nickname,
    props.gender,
    props.sexualOrientation,
    props.personalEmail,
    props.phoneNumber,
    props.dob,
    props.currentAddress,
    props.city,
    props.nationality,
    props.country,
    props.rehabId,
    props.rehabCountry,
    props.durationOfStay,
    props.dateOfAdmission,
    props.projectedResidentialDischargeDate,
    props.maritalStatus,
    props.livingWith,
    props.projectedProgramCompletionDate,
    props.passportNumber,
    props.roomNumber,
    props.visaExpirationDate,
    props.emergencyContactFirstName,
    props.emergencyContactLastName,
    props.emergencyContactRelationship,
    props.emergencyContactPhoneNumber,
    props.emergencyContactEmail,
    props.emergencyContactAddress,
    props.emergencyContactCity,
    props.emergencyContactNationality,
    props.emergencyContactCountry,
    props.emergencyRelationshipOther,
    props.payerName,
    props.payerPhoneNumber,
    props.inTakestaffName,
    props.intakeStaffId,
    props.intakeStaffEmail,
    props.clientStatus,
    props.age,
    props.lastModification,
    props.fileUrls,
    props.genderOther,
    props.sexualOrientationOther,
    props.livingWithOther,
    props.province,
    props.emergencyCheckbox0,
    props.emergencyCheckbox1,
    props.emergencyCheckbox2,
    props.emergencyCheckbox3,
    props.emergencyCheckbox4,
    props.emergencyCheckbox5,
    props.emergencyCheckbox6,
    props.emergencyCheckbox7,
    props.emergencyCheckbox8,
    props.emergencyCheckbox9,
    props.emergencyCheckbox10,
    props.emergencyCheckbox11,
    props.emergencyCheckbox12,
    props.emergencyCheckbox13,
    props.emergencyCheckbox14,
    props.emergencyCheckbox15,
    props.emergencyCheckboxContent15,
    props.emergencyCheckboxContent15Input,
    props.assignedSupportWorker,
    props.therapistAppointment,
    props.supportWorkerAppointment,
    props.medicalAppointment,
    props.visaAppointment,
    props.stepsAppointment,
    props.massageDay,
  ]);

  const { currentUser } = useAuth();

  useEffect(() => {
    props.onModificationChange(isModified);
  }, [isModified]);


  const showLogDetails = (selectedLog) => {
    const changes = selectedLog.changes;
    const who = selectedLog.recordedBy;
    const when = formatDateLogs(selectedLog.recordedAt);

    return (
      <div className="pre-admission-detail-content">
        <div className="pre-admission-detail-summary">
          <span>Recorded by</span>
          <strong>{who}</strong>
          <time>{when}</time>
        </div>
        <div className="pre-admission-change-list">
          {Object.entries(changes)
            .filter(([key]) => key !== "lastModification")
            .map(([key, value]) => (
              <article className="pre-admission-change-card" key={key}>
                <div className="pre-admission-change-field">{key}</div>
                <div className="pre-admission-change-label">New value</div>
                <div className="pre-admission-change-value">
                  {typeof value === "string" ? value : JSON.stringify(value, null, 2)}
                </div>
              </article>
            ))}
          {/*
            alignItems: "center", // Ajouté pour centrer verticalement le contenu
            padding: "10px 20px",
          }}
        >
          {Object.entries(changes)
        <div
          style={{
            width: "100%",
            flex: 1,
            overflowY: "auto",
          }}
        >
        </div> */}
        </div>
      </div>
    );
  };

  function formatDate3(value) {
    // Assurez-vous que la valeur est une instance de Timestamp
    // et convertissez-la en objet Date, puis formatez-la.
    if (value && value.toDate) {
      return value.toDate().toLocaleString("en-EN", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    }
    return value;
  }

  const handleShowDetailsClick = (selectedLog) => {
    const sortedLogs = logs.sort(
      (a, b) => b.recordedAt.toDate() - a.recordedAt.toDate()
    );

    const selectedIndex = sortedLogs.findIndex(
      (log) => log.id === selectedLog.id
    );

    if (selectedIndex === -1) {
      setSelectedLog({ ...selectedLog, changes: selectedLog.changes });
    } else {
      const previousLog = sortedLogs[selectedIndex + 1];

      let differences = {};
      Object.keys(selectedLog.changes).forEach((key) => {
        let currentValue = selectedLog.changes[key];
        const previousValue = previousLog
          ? previousLog.changes[key]
          : undefined;

        // Appliquer le formatage si la valeur est un timestamp
        currentValue = formatDate3(currentValue);

        // Vérifiez que la valeur actuelle n'est pas vide avant de l'ajouter
        if (
          (!previousLog ||
            JSON.stringify(currentValue) !== JSON.stringify(previousValue)) &&
          currentValue !== undefined &&
          currentValue !== null &&
          currentValue !== ""
        ) {
          differences[key] = currentValue;
        }
      });

      setSelectedLog({ ...selectedLog, changes: differences });
    }

    setIsDetailsModalOpen(true);
  };

  const fetchLogs = async (clientId) => {
    setIsLoadingFetchLogs(true);
    try {
      const querySnapshot = await getDocs(
        collection(db, "logs-general-infos", clientId, "modifications")
      );
      const fetchedLogs = [];
      querySnapshot.forEach((doc) => {
        fetchedLogs.push({ id: doc.id, ...doc.data() });
      });
      setLogs(fetchedLogs);
    } catch (error) {
      console.error("Error fetching logs: ", error);
    } finally {
      setIsLoadingFetchLogs(false);
    }
  };

  const openModalLogs = (clientId) => {
    fetchLogs(clientId);
    setIsModalLogsOpen(true);
  };

  const formatDateLogs = (timestamp) => {
    const date = timestamp.toDate();
    return date.toLocaleString(); // Formate la date selon la locale de l'environnement
  };

  return (
    <div className="tab-container-white-mobile-bis">
      <div className="container-main-plan-mobile-2">
        {isDetailsModalOpen && (
          <StandardDrawer
            open={isDetailsModalOpen}
            onClose={() => setIsDetailsModalOpen(false)}
            SlideProps={{ direction: "left" }}
          >
            <div className="standard-drawer-form-wrapper">
              <StandardDrawerHeader eyebrow="GENERAL INFORMATION" title="Activity log details" subtitle="Change history" onClose={closeDetailLogsModal} />
              {selectedLog && showLogDetails(selectedLog, closeDetailLogsModal)}
              <StandardDrawerFooter><Button variant="contained" onClick={closeDetailLogsModal}>Close</Button></StandardDrawerFooter>
            </div>
          </StandardDrawer>
        )}
        {isModalLogsOpen && (
          <StandardDrawer
            open={isModalLogsOpen}
            onClose={() => setIsModalLogsOpen(false)}
            SlideProps={{ direction: "left" }}
          >
            <div className="standard-drawer-form-wrapper">
              <StandardDrawerHeader eyebrow="GENERAL INFORMATION" title="Activity logs" subtitle={`${logs.length} recorded changes`} onClose={closeLogsModal} />
              <div className="pre-admission-activity-body">
                {logs
                  .sort((a, b) => b.recordedAt.toDate() - a.recordedAt.toDate())
                  .map((log) => (
                    <LineLogsMobile
                      key={log.id}
                      log={log}
                      onDetailsClick={() => handleShowDetailsClick(log)}
                    />
                  ))}
              </div>
              <StandardDrawerFooter><Button variant="contained" onClick={closeLogsModal}>Close</Button></StandardDrawerFooter>
            </div>
          </StandardDrawer>
        )}
        <div className="tab-container-title-mobile-3 ">
          {/* <div>General Information </div> */}

          <button
            type="button"
            className="pre-admission-activity-button"
            style={{
            }}
            onClick={() => openModalLogs(props.clientId)}
          >
            <span className="pre-admission-activity-icon">↻</span>
            Activity Logs
            <span className="pre-admission-activity-count">{logs.length}</span>
          </button>

          <span
            style={{
              fontSize: "12px",
              fontStyle: "italic",
            }}
          >
            {props.creatorName && props.dateOfCreation && (
              <div
                style={{
                  fontSize: "12px",
                  fontStyle: "italic",
                  paddingLeft: "5px",
                  paddingRight: "5px",
                }}
              >
                {`Client added by ${props.creatorName} on ${props.dateOfCreation
                  .toDate()
                  .toLocaleString("en-US", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                  })}`}
              </div>
            )}
            {/* {props.lastModificationDoneBy && props.lastModification
              ? `( Last modifications done by ${
                  props.lastModificationDoneBy
                } on ${props.lastModification.toDate().toLocaleString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                })})`
              : "No modifications done "} */}
          </span>
        </div>

        <div className="tab-form-container-mobile-v2">
          <InputComponent
            title="Firstname"
            width="auto"
            value={firstName}
            onChange={handleFirstNameChange}
          />
          <InputComponent
            title="Lastname"
            width="auto"
            value={lastName}
            onChange={handleLastNameChange}
          />
          <InputComponent
            title="Nickname"
            width="auto"
            value={nickname}
            onChange={handleNicknameChange}
          />

          <DropDownComponentSorted
            api="clientSource"
            title="Client source"
            value={clientSource}
            onChange={handleClientSourceChange}
          />
        </div>

        <div className="tab-form-container">
          {/* <DropDownComponent
            api="clientStatus"
            title="Client status"
            value={clientStatus}
            onChange={handleClientStatusChange}
          /> */}
          {/* <InputComponent
            title="Room number"
            width="100px"
            value={roomNumber}
            onChange={handleRoomNumberChange}
          /> */}

          <DropDownRoomsNumber
            title="Room number"
            width="100px"
            value={roomNumber}
            onChange={handleRoomNumberChange}
            clientId={clientIdState}
            clientStatus={props.clientStatus}
            clientFirstName={firstName}
            clientLastName={lastName}
            profilePictureUrl={profilePicture}
          />
          <DropDownAllStaffs
            title="Assigned Therapist"
            value={selectedTherapist}
            width="auto"
            onChange={handleSelectedTherapistChange}
          />

          <DropDownSpecificStaff
            title="Assigned Support Worker"
            value={assignedSupportWorker}
            onChange={handleAssignedSupportWorkerChange}
            allowedRoles={["Support Staff", "Psycho-ed"]}
          />
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            paddingRight: "30px",
          }}
        >
          {/* <DatePickerComponentWithTimeMobile
            title="Therapist Appointment"
            width="150px"
            value={therapistAppointment}
            onChange={handleTherapistAppointmentChange}
          /> */}

          <FormControl fullWidth sx={{ mb: 1 }}>
            <InputLabel id="ther-days-label">Therapist Days</InputLabel>
            <Select
              labelId="ther-days-label"
              label="Therapist Days"
              value={therapistAppointmentDays}
              onChange={(e) =>
                handleTherapistAppointmentDaysChange(e.target.value)
              }
            >
              <MenuItem value="MON/THUR">MON/THUR</MenuItem>
              <MenuItem value="TUE/FRI">TUE/FRI</MenuItem>
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 1 }}>
            <InputLabel id="ther-time-label">Therapist Time</InputLabel>
            <Select
              labelId="ther-time-label"
              label="Therapist Time"
              value={therapistAppointmentTime}
              onChange={(e) =>
                handleTherapistAppointmentTimeChange(e.target.value)
              }
            >
              <MenuItem value="13:10">1:10 PM</MenuItem>
              <MenuItem value="14:10">2:10 PM</MenuItem>
              <MenuItem value="15:10">3:10 PM</MenuItem>
              <MenuItem value="16:10">4:10 PM</MenuItem>
            </Select>
          </FormControl>

          {/* <DatePickerComponentWithTimeMobile
            title="Support Worker Appointment"
            width="150px"
            value={supportWorkerAppointment}
            onChange={handleSupportWorkerAppointmentChange}
          />

<DatePickerComponentWithTimeMobile
            title="12 Steps Appointment"
            width="150px"
            value={stepsAppointment}
            onChange={handleStepsAppointmentChange}
          /> */}

          {/* — Support Worker & 12 Steps Appointments (mobile) — */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 8,
              marginBottom: 16,
            }}
          >
            {/* Support Worker Day + Time */}
            <FormControl fullWidth sx={{ mb: 1 }}>
              <InputLabel id="sw-days-label">SW Appt Day</InputLabel>
              <Select
                labelId="sw-days-label"
                label="SW Appt Day"
                value={supportWorkerAppointmentDays}
                onChange={(e) =>
                  handleSupportWorkerAppointmentDaysChange(e.target.value)
                }
              >
                {[
                  "MONDAY",
                  "TUESDAY",
                  "WEDNESDAY",
                  "THURSDAY",
                  "FRIDAY",
                  "SATURDAY",
                  "SUNDAY",
                ].map((d) => (
                  <MenuItem key={d} value={d}>
                    {d}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 1 }}>
              <InputLabel id="sw-time-label">SW Appt Time</InputLabel>
              <Select
                labelId="sw-time-label"
                label="SW Appt Time"
                value={supportWorkerAppointmentTime}
                onChange={(e) =>
                  handleSupportWorkerAppointmentTimeChange(e.target.value)
                }
              >
                {generateTimeOptions().map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {/* 12 Steps Day + Time */}
            <FormControl fullWidth sx={{ mb: 1 }}>
              <InputLabel id="steps-days-label">12 Steps Day</InputLabel>
              <Select
                labelId="steps-days-label"
                label="12 Steps Day"
                value={stepsAppointmentDays}
                onChange={(e) =>
                  handleStepsAppointmentDaysChange(e.target.value)
                }
              >
                {[
                  "MONDAY",
                  "TUESDAY",
                  "WEDNESDAY",
                  "THURSDAY",
                  "FRIDAY",
                  "SATURDAY",
                  "SUNDAY",
                ].map((d) => (
                  <MenuItem key={d} value={d}>
                    {d}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 1 }}>
              <InputLabel id="steps-time-label">12 Steps Time</InputLabel>
              <Select
                labelId="steps-time-label"
                label="12 Steps Time"
                value={stepsAppointmentTime}
                onChange={(e) =>
                  handleStepsAppointmentTimeChange(e.target.value)
                }
              >
                {generateTimeOptions().map((opt) => (
                  <MenuItem key={opt.value} value={opt.value}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <DatePickerComponentWithTimeMobile
            title="Medical Appointment"
            width="150px"
            value={medicalAppointment}
            onChange={handleMedicalAppointmentChange}
          />
          <DatePickerComponentWithTimeMobile
            title="Visa Appointment"
            width="150px"
            value={visaAppointment}
            onChange={handleVisaAppointmentChange}
          />
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
          <DropDownComponentSortedFixed
            api="daysOfWeek" // Vous pouvez adapter cette prop selon votre implémentation
            title="Massage day"
            value={massageDay}
            onChange={handleMassageDayChange}
          />
        </div>

        <div className="tab-form-container">
          <DatePickerComponent
            title="Birthday"
            width="150px"
            value={dob}
            onChange={handleDobChange}
          />

          <InputComponentReadOnly
            title="Age (not editable)"
            width="100px"
            value={age}
            // onChange={handleAgeChange}
          />

          <DropDownComponent
            api="maritalStatus"
            title="Marital status"
            value={maritalStatus}
            onChange={handleMaritalStatusChange}
          />
          <DropDownComponentSorted
            api="relationship"
            title="Living with"
            value={livingWith}
            onChange={handleLivingWithChange}
          />
        </div>

        <div className="tab-form-container">
          <DropDownComponent
            api="gender"
            title="Gender"
            value={gender}
            onChange={handleGenderChange}
          />

          {gender === "Other" ? (
            <InputComponent
              title="If other gender, describe"
              width="100px"
              value={genderOther}
              onChange={handleGenderOther}
            />
          ) : (
            ""
          )}

          <DropDownComponent
            api="sexualOrientation"
            title="Sexual orientation"
            value={sexualOrientation}
            onChange={handleSexualOrientationChange}
          />

          {sexualOrientation === "other" ? (
            <InputComponent
              title="If other, describe"
              width="100px"
              value={sexualOrientationOther}
              onChange={handleSexualOrientationOther}
            />
          ) : (
            ""
          )}

          <InputComponent
            title="Client Email"
            width="auto"
            value={personalEmail}
            onChange={handlePersonalEmailChange}
          />

          <PhoneNumberInput
            title="Client phone number"
            value={phoneNumber}
            onChange={handlePhoneNumberChange}
          />

          {livingWith === "Other" ? (
            <InputComponent
              title="If other, describe"
              width="80px"
              value={livingWithOther}
              onChange={handleLivingWithOther}
            />
          ) : (
            ""
          )}
        </div>
        <div className="tab-form-container">
          <InputComponent
            title="Passport number"
            width="150px"
            value={passportNumber}
            onChange={handlePassportNumberChange}
          />
          <DatePickerComponent
            title="Visa expiration date"
            width="150px"
            value={visaExpirationDate}
            onChange={handleVisaExpirationDateChange}
          />
        </div>
        <div className="tab-form-container">
          <TextFieldComponentMobile
            title="Physical address of residence"
            value={currentAddress}
            onChange={handleCurrentAddressChange}
          />
        </div>

        <div className="tab-form-container">
          <div className="block-input">
            <div className="block-input-line1">
              <div className="input-label-container">
                <div className="input-label">Rehab / Facility</div>
                <select
                  className="add-client-rehab-select"
                  value={rehabId}
                  onChange={handleRehabChange}
                >
                  {rehabs.map((rehab) => (
                    <option key={rehab.id} value={rehab.id}>
                      {rehab.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="block-input-line1">
              <InputComponent
                title="City"
                width="auto"
                value={city}
                onChange={handleCityChange}
              />
              <InputComponent
                title="Province / State"
                width="150px"
                value={province}
                onChange={handleProvinceChange}
              />
            </div>
            <div className="block-input-line2">
              <DropDownComponent
                api="nationalities"
                title="Nationality"
                value={nationality}
                onChange={handleNationalityChange}
              />
              <DropDownComponent
                api="countries"
                title="Country"
                value={country}
                onChange={handleCountryChange}
              />
            </div>
          </div>
        </div>

        <div style={{ width: "95%" }}>
          <UploaderGeneralInfosEncapsulated {...props} />
        </div>
      </div>

      <div className="container-main-plan-blue">
        {/* <div className="tab-form-container-blue"> */}
        <div className="tab-container-title-mobile-3">
          Admission / discharge
        </div>
        <div className="tab-form-container">
          {requiresDurationOfStay && (
            <DropDownComponentSorted
              api="durationOfStay"
              title="Intended duration of stay"
              width="250px"
              value={durationOfStay}
              onChange={handleDurationOfStayChange}
            />
          )}
          <DatePickerComponent
            title="Actual admission date"
            width="250px"
            value={dateOfAdmission}
            onChange={handleDateOfAdmissionChange}
          />
        </div>

        <div className="tab-form-container">
          <DatePickerComponent
            title="Projected discharge date "
            width={250}
            value={projectedResidentialDischargeDate}
            onChange={handleProjectedResidentialDischargeDateChange}
          />

          {/* {dischargeDate ? ( */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: 0,
            }}
          >
            {/* <div
                style={{
                  fontWeight: "400",
                  fontSize: 12,
                  marginTop: 10,
                  marginLeft: 10,
                }}
              >
                Actual discharge date
              </div>
              <div
                style={{
                  fontWeight: "400",
                  fontSize: 16,
                  marginTop: 14,
                  marginLeft: 10,
                  paddingLeft: 5,
                  paddingTop: 5,
                  paddingBottom: 5,
                  border: "1px solid #000", // Ajoute un trait autour du contenu
                  borderRadius: "5px",
                  textAlign: "center",
                }}
              >
                {formatDate2(dischargeDate)}
              </div> */}
            <DatePickerComponent
              title="Actual discharge date"
              width={250}
              value={dischargeDate}
              onChange={handleDischargeDateChange}
            />
          </div>
          {/* ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100px", // Ou la hauteur que vous souhaitez
                paddingLeft: 20,
                color: "red",
              }}
            >
              No discharge report filled yet
            </div>
          )} */}

          <DatePickerComponent
            title="Projected aftercare completion date"
            width={250}
            value={projectedProgramCompletionDate}
            onChange={handleProjectedProgramCompletionDateChange}
          />
        </div>
        {/* </div> */}
      </div>

      <div className="container-main-plan-red">
        {/* <div className="tab-form-container-red"> */}
        <div className="tab-container-title">Emergency contact</div>
        <div className="tab-form-container-fied">
          <InputComponent
            title="Emergency contact first name"
            width="auto"
            value={emergencyContactFirstName}
            onChange={handleEmergencyContactFirstNameChange}
          />
          <InputComponent
            title="Emergency contact last name"
            width="auto"
            value={emergencyContactLastName}
            onChange={handleEmergencyContactLastNameChange}
          />
          <DropDownComponentSorted
            api="relationship"
            title="Relationship"
            value={emergencyContactRelationship}
            onChange={handleEmergencyContactRelationshipChange}
          />

          {emergencyContactRelationship === "Other" ? (
            <InputComponent
              title="If other, describe"
              width="100px"
              value={emergencyRelationshipOther}
              onChange={handleEmergencyRelationshipOther}
            />
          ) : (
            ""
          )}

          <PhoneNumberInput
            title="Contact phone number"
            value={emergencyContactPhoneNumber}
            onChange={handleEmergencyContactPhoneNumberChange}
          />

          <InputComponent
            title="Contact Email"
            width="auto"
            value={emergencyContactEmail}
            onChange={handleEmergencyContactEmailChange}
          />
        </div>

        <div className="tab-form-container-fied">
          <TextFieldComponentMobile
            title="Physical address of residence"
            value={emergencyContactAddress}
            onChange={handleEmergencyContactAddressChange}
          />
          <div className="block-input">
            <div className="block-input-line1">
              <InputComponent
                title="City"
                width="auto"
                value={emergencyContactCity}
                onChange={handleEmergencyContactCityChange}
              />
            </div>
            <div className="block-input-line2">
              <DropDownComponent
                api="nationalities"
                title="Nationality"
                value={emergencyContactNationality}
                onChange={handleEmergencyContactNationalityChange}
              />
              <DropDownComponentSorted
                api="countries"
                title="Country"
                value={emergencyContactCountry}
                onChange={handleEmergencyContactCountryChange}
              />
            </div>
          </div>
        </div>

        <div className="tab-form-container-fied">
          <InputComponent
            title="Name of the person paying for the treatment"
            width="auto"
            value={payerName}
            onChange={handlePayerNameChange}
          />
          <PhoneNumberInput
            title="Phone number of person paying"
            value={payerPhoneNumber}
            onChange={handlePayerPhoneNumberChange}
          />
        </div>
        {/* </div> */}

        <div className="SubTitleBold4">
          The specific and relevant information that may be released / obtained
          is:
        </div>

        <div className="yes-no-container-column">
          <div className="checkbox-container">
            <Checkbox
              checked={acknowledgmentOfPresence}
              onChange={handleAcknowledgmentOfPresenceChange}
            />
            Acknowledgment of Presence in Treatment
          </div>

          <div className="checkbox-container">
            <Checkbox
              checked={clinicalInformation}
              onChange={handleClinicalInformationChange}
            />
            Clinical information for insurance
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={psychEvaluation}
              onChange={handlePsychEvaluationChange}
            />
            Psychiatric or psychological evaluation
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={referralLetter}
              onChange={handleReferralLetterChange}
            />
            Referral letter
          </div>
          <div className="checkbox-container">
            <Checkbox checked={labData} onChange={handleLabDataChange} />
            Lab data / drug screens
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={progressNotes}
              onChange={handleProgressNotesChange}
            />
            Progress notes
          </div>

          <div className="checkbox-container">
            <Checkbox
              checked={medicalRecords}
              onChange={handleMedicalRecordsChange}
            />
            Medical / hospital records
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={progressInTreatment}
              onChange={handleProgressInTreatmentChange}
            />
            Progress in treatment
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={psychosocialAssessment}
              onChange={handlePsychosocialAssessmentChange}
            />
            Psychosocial assessment
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={medicationInfo}
              onChange={handleMedicationInfoChange}
            />
            Medication information
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={treatmentPlan}
              onChange={handleTreatmentPlanChange}
            />
            Treatment plan
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={physicalAssessment}
              onChange={handlePhysicalAssessmentChange}
            />
            Physical Assessment
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={dischargeSummary}
              onChange={handleDischargeSummaryChange}
            />
            Discharge summary
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={familyHistory}
              onChange={handleFamilyHistoryChange}
            />
            Family/ Significant Other history
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={dischargePlan}
              onChange={handleDischargePlanChange}
            />
            Discharge plan
          </div>
          <div className="checkbox-container">
            <Checkbox
              checked={admissionDischargeDates}
              onChange={handleAdmissionDischargeDatesChange}
            />
            Admission and discharge dates
          </div>
          <div className="checkbox-container">
            <Checkbox checked={otherInfo} onChange={handleOtherInfoChange} />
            Other
            {otherInfo ? (
              <InputComponent
                value={otherInfoInput}
                onChange={handleOtherInfoInputChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      <div className="button-container-form-gi-mobile">
        <Button
          variant="contained"
          onClick={() => updateClientData(props.clientId)}
          style={
            isModified && !isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "15px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "25px",
            marginRight: "30px",
          }}
        >
          {isLoading
            ? "SAVING MODIFICATIONS..."
            : isModified
            ? "CLICK TO SAVE"
            : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default GeneralInformationMobile;
